import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';
import { Box, Divider, Slide } from '@material-ui/core';
import Routes from 'routes';
import { wait } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import { ReactComponent as SuccessIcon } from 'assets/images/billings-upgrade/upgrade-enterprise-send-success.svg';
import FsPendingButton from 'ui-elements/buttons/FsPendingButton';
import FsButton from 'ui-elements/buttons/FsButton';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import TailoredPricing from './TailoredPricing';

const Enterprise: React.FC = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [isEnterpriseFormValid, setIsEnterpriseFormValid] = useState<boolean>(
    false
  );
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [pending, setPending] = useState<boolean>(false);

  const cancelRedirect = (): void => {
    history.push({ pathname: Routes.ROOT });
  };

  const handleSend = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setPending(true);
    // eslint-disable-next-line no-console
    console.log('Subscribe');
    await wait(1000);
    setPending(false);
    enqueueSnackbar(defaultLocales.messageSendNotificationSuccess, {
      variant: 'success',
    });
    setShowSuccess(true);
  };

  return (
    <>
      {showSuccess ? (
        <Slide direction="left" in timeout={300}>
          <Box>
            <FsAlertBoard
              title={defaultLocales.success}
              maxWidth={440}
              icon={<SuccessIcon />}
              buttonLabel={defaultLocales.backToDashboard}
              url={Routes.ROOT}
            >
              {defaultLocales.enterpriseMessageSendSuccessModalInfo}
            </FsAlertBoard>
          </Box>
        </Slide>
      ) : (
        <Box maxWidth={622}>
          <Box marginBottom={4}>
            <TailoredPricing
              onChange={(isValid) => setIsEnterpriseFormValid(isValid)}
            />
          </Box>
          <Box marginBottom={4}>
            <Divider />
          </Box>
          <Box marginBottom={6}>
            <FsPendingButton
              onClick={handleSend}
              variant="contained"
              color="primary"
              pending={pending}
              width={160}
              disabled={!isEnterpriseFormValid}
            >
              {defaultLocales.send}
            </FsPendingButton>
            <Box display="inline-block" ml={1}>
              <FsButton color="inherit" onClick={() => cancelRedirect()}>
                {defaultLocales.cancel}
              </FsButton>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Enterprise;
